<template>
    <card-tabs selected-name="appointment">
        <template #labels>
            <appointment-card-tab-label :appointment-collection="appointmentCollection as ReactiveCollection<Appointment>" />
            <task-card-tab-label :task-overview="taskOverview" />
        </template>
        <template #panels>
            <appointments-tab-panel :appointment-collection="appointmentCollection as ReactiveCollection<Appointment>" />
            <tasks-tab-panel :task-overview="taskOverview" />
        </template>
    </card-tabs>
</template>

<script setup lang="ts">
    import {
        CardTabs,
    } from '@keyvue/one-ui';

    import { Appointment } from '@keyvue/one-api-client';
    import { provide } from 'vue';
    import useClient, { type ReactiveCollection } from '@/composables/useClient';
    import { onBeforeRouteUpdate } from 'vue-router';
    import TaskCardTabLabel from '@components/Tabs/Labels/TaskCardTabLabel.vue';
    import AppointmentCardTabLabel from '@components/Tabs/Labels/AppointmentCardTabLabel.vue';
    import AppointmentsTabPanel from '@components/Tabs/Panels/AppointmentsTabPanel.vue';
    import TasksTabPanel from '@components/Tabs/Panels/TasksTabPanel.vue';
    import useEventBus from '@composables/useEventBus';
    import useTaskOverview from '@composables/useTaskOverview';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();
    const { getReactiveCollection } = useClient();
    const { getTaskOverview } = useTaskOverview();
    const eventBus = useEventBus();

    const [
        appointmentCollection,
        taskOverview,
    ] = await Promise.all([
        getReactiveCollection(Appointment, { 'lead.primaryContact': props.contactId }),
        getTaskOverview({ 'lead.primaryContact': props.contactId }),
    ]);

    provide('appointmentCollection', appointmentCollection);

    onBeforeRouteUpdate(async (to) => {
        if (to.name !== 'contactDetail') {
            return;
        }

        await Promise.all([
            taskOverview.load(),
            appointmentCollection.load(),
        ]);
    });

    eventBus.subscribe<string>('resource-manipulated', async (params) => {
        if (params === 'Task') {
            await taskOverview.load();
        }
    });

    eventBus.subscribe<string>('resource-manipulated', async (params) => {
        if (params === 'Appointment') {
            await appointmentCollection.load();
        }
    });
</script>
